<template>
  <v-menu
    class="notify-menu"
    offset-y
    max-height="500"
    max-width="800"
    origin="center center"
    :nudge-bottom="10"
    transition="scale-transition"
    offset-x
    :close-on-content-click="false"
    :content-class="notificationsCount < 5 || items.length < 5 ? 'my-menu' : ''"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon text v-on="on">
        <v-badge
          class="notif-badge m-auto"
          color="$neutral-pink-1"
          overlap
          bordered
        >
          <template v-slot:badge>
            <span>{{ notificationsCount }}</span>
          </template>
          <v-icon :class="isBellAnimation ? 'bell' : ''"
            >mdi-bell-outline</v-icon
          >
        </v-badge>
      </v-btn>
    </template>
    <v-card :width="items.length > 0 ? '700' : ''">
      <v-list class="pa-0" two-line subheader>
        <v-row v-if="notificationsCount > 0 || items.length > 0">
          <v-col cols="6" md="6">
            <v-subheader class="notify-title">Notifications</v-subheader>
          </v-col>
          <v-col cols="6" md="6" class="text-right">
            <v-btn
              class="mark-all-btn"
              v-if="notificationsCount != 0"
              x-small
              rounded
              outlined
              color="#bf2e1a"
              dark
              @click="SaveMarkAsAllViewed()"
              >Mark all as read</v-btn
            >
          </v-col>
        </v-row>
        <v-divider />
        <v-list-item-group v-if="items.length > 0">
          <div :key="item.id" v-for="(item, index) in items">
            <v-list-item @click="handleClickItem(item)" class="notify-list">
              <v-list-item-content class="py-1">
                <v-list-item-title
                  :class="item.status == 0 ? '' : 'notify-font-style'"
                >
                  <div class="d-flex">
                    <span class="notif-font"> {{ item.title }}</span>
                    <span>
                      <span class="pl-8">{{
                        item.createdDate | formattoLocalDate
                      }}</span></span
                    >
                    <span class="ml-auto">
                      <v-chip
                        v-if="
                          item.criticality != null && item.criticality != ''
                        "
                        :color="
                          item.criticality.toLowerCase() == 'critical'
                            ? 'error'
                            : item.criticality.toLowerCase() == 'high'
                            ? 'warning'
                            : item.criticality.toLowerCase() == 'low'
                            ? 'primary'
                            : item.criticality.toLowerCase() == 'none'
                            ? ''
                            : ''
                        "
                        small
                        >{{ item.criticality }}</v-chip
                      ></span
                    >
                  </div>
                  <v-tooltip top v-if="item.message.length > 70">
                    <template v-slot:activator="{ on, attrs }">
                      <p
                        v-bind="attrs"
                        v-on="on"
                        class="text-subtitle-2 font-weight-regular mb-1"
                      >
                        {{
                          item.message.length > 70
                            ? item.message.substring(0, 70) + "...."
                            : item.message
                        }}
                      </p></template
                    >
                    <span>{{ item.message }}</span>
                  </v-tooltip>
                  <p v-else class="text-subtitle-2 font-weight-regular mb-1">
                    {{ item.message }}
                  </p>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider v-if="index < items.length - 1" :key="index"></v-divider>
          </div>
        </v-list-item-group>
        <v-list-item-group v-else>
          <v-list-item class="notify-list">
            <v-list-item-content>
              <v-list-item-title> You have no notifications</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-divider />
      <v-subheader v-if="isShow && notificationsCount > 5">
        <v-row class="show-mark-btn">
          <v-col cols="12" md="12" class="text-center">
            <v-btn
              x-small
              rounded
              outlined
              class="badge-color"
              color="primary"
              dark
              @click="showAllNotifications"
              >Show All</v-btn
            >
          </v-col>
        </v-row>
      </v-subheader>
    </v-card>
  </v-menu>
</template>

<style scoped>
.notif-badge {
  /* margin-right:50px !important; */
  /* color: white; */
  color: #060606;
}

.notify-icon {
  font-size: 20px !important;
}
.notify-title {
  font-size: 16px !important;
  font-weight: 600 !important;
}
.notify-font-style {
  font-weight: 600 !important;
}
.notif-font {
  /* font-weight: 600 !important; */
  font-size: 16px !important;
}
.notify-menu {
  height: 50% !important;
}
.notify-list {
  padding: 0px 30px !important;
}
.notify-list .v-list-item__title {
  font-size: 0.8rem !important;
}
.show-mark-btn {
  padding: 0px 16px;
}
.mark-all-btn {
  margin: 16px 16px 0px 16px;
}
.my-menu {
  margin-top: 5px;
  contain: initial;
  overflow: visible;
}
.my-menu::before {
  position: absolute;
  content: "";
  top: 0;
  right: 50px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #fff;
}
.bell {
  display: block;
  color: #9e9e9e;
  -webkit-animation: ring 4s 0.7s ease-in-out infinite;
  -webkit-transform-origin: 50% 4px;
  -moz-animation: ring 4s 0.7s ease-in-out infinite;
  -moz-transform-origin: 50% 4px;
  animation: ring 4s 0.7s ease-in-out infinite;
  transform-origin: 50% 4px;
}

.v-menu__content {
  top: 60px !important;
  box-shadow: rgb(26 27 28 / 15%) 0px 1px 1px,
    rgb(26 27 28 / 13%) 0px 0px 1px 1px !important;
  border: none !important;
}

@-webkit-keyframes ring {
  0% {
    -webkit-transform: rotateZ(0);
  }
  1% {
    -webkit-transform: rotateZ(30deg);
  }
  3% {
    -webkit-transform: rotateZ(-28deg);
  }
  5% {
    -webkit-transform: rotateZ(34deg);
  }
  7% {
    -webkit-transform: rotateZ(-32deg);
  }
  9% {
    -webkit-transform: rotateZ(30deg);
  }
  11% {
    -webkit-transform: rotateZ(-28deg);
  }
  13% {
    -webkit-transform: rotateZ(26deg);
  }
  15% {
    -webkit-transform: rotateZ(-24deg);
  }
  17% {
    -webkit-transform: rotateZ(22deg);
  }
  19% {
    -webkit-transform: rotateZ(-20deg);
  }
  21% {
    -webkit-transform: rotateZ(18deg);
  }
  23% {
    -webkit-transform: rotateZ(-16deg);
  }
  25% {
    -webkit-transform: rotateZ(14deg);
  }
  27% {
    -webkit-transform: rotateZ(-12deg);
  }
  29% {
    -webkit-transform: rotateZ(10deg);
  }
  31% {
    -webkit-transform: rotateZ(-8deg);
  }
  33% {
    -webkit-transform: rotateZ(6deg);
  }
  35% {
    -webkit-transform: rotateZ(-4deg);
  }
  37% {
    -webkit-transform: rotateZ(2deg);
  }
  39% {
    -webkit-transform: rotateZ(-1deg);
  }
  41% {
    -webkit-transform: rotateZ(1deg);
  }

  43% {
    -webkit-transform: rotateZ(0);
  }
  100% {
    -webkit-transform: rotateZ(0);
  }
}

@-moz-keyframes ring {
  0% {
    -moz-transform: rotate(0);
  }
  1% {
    -moz-transform: rotate(30deg);
  }
  3% {
    -moz-transform: rotate(-28deg);
  }
  5% {
    -moz-transform: rotate(34deg);
  }
  7% {
    -moz-transform: rotate(-32deg);
  }
  9% {
    -moz-transform: rotate(30deg);
  }
  11% {
    -moz-transform: rotate(-28deg);
  }
  13% {
    -moz-transform: rotate(26deg);
  }
  15% {
    -moz-transform: rotate(-24deg);
  }
  17% {
    -moz-transform: rotate(22deg);
  }
  19% {
    -moz-transform: rotate(-20deg);
  }
  21% {
    -moz-transform: rotate(18deg);
  }
  23% {
    -moz-transform: rotate(-16deg);
  }
  25% {
    -moz-transform: rotate(14deg);
  }
  27% {
    -moz-transform: rotate(-12deg);
  }
  29% {
    -moz-transform: rotate(10deg);
  }
  31% {
    -moz-transform: rotate(-8deg);
  }
  33% {
    -moz-transform: rotate(6deg);
  }
  35% {
    -moz-transform: rotate(-4deg);
  }
  37% {
    -moz-transform: rotate(2deg);
  }
  39% {
    -moz-transform: rotate(-1deg);
  }
  41% {
    -moz-transform: rotate(1deg);
  }

  43% {
    -moz-transform: rotate(0);
  }
  100% {
    -moz-transform: rotate(0);
  }
}

@keyframes ring {
  0% {
    transform: rotate(0);
  }
  1% {
    transform: rotate(30deg);
  }
  3% {
    transform: rotate(-28deg);
  }
  5% {
    transform: rotate(34deg);
  }
  7% {
    transform: rotate(-32deg);
  }
  9% {
    transform: rotate(30deg);
  }
  11% {
    transform: rotate(-28deg);
  }
  13% {
    transform: rotate(26deg);
  }
  15% {
    transform: rotate(-24deg);
  }
  17% {
    transform: rotate(22deg);
  }
  19% {
    transform: rotate(-20deg);
  }
  21% {
    transform: rotate(18deg);
  }
  23% {
    transform: rotate(-16deg);
  }
  25% {
    transform: rotate(14deg);
  }
  27% {
    transform: rotate(-12deg);
  }
  29% {
    transform: rotate(10deg);
  }
  31% {
    transform: rotate(-8deg);
  }
  33% {
    transform: rotate(6deg);
  }
  35% {
    transform: rotate(-4deg);
  }
  37% {
    transform: rotate(2deg);
  }
  39% {
    transform: rotate(-1deg);
  }
  41% {
    transform: rotate(1deg);
  }

  43% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(0);
  }
}
</style>
<script>
// import telematicsService from "@/api/telematics.service";
import apiService from "../../api/api.service";
import { mapGetters } from "vuex";
import config from "@/config";
import moment from "moment";

export default {
  name: "AppNotification",
  data: () => ({
    isShow: true,
    items: [],
    notificationsCount: 0,
    notificationsList: [],
    isBellAnimation: false,
    isMarkingAllRead: false,
    pollingNotifications: null,
  }),
  created() {
    // Get Notifications for every NOTIFICATION_REFRESH_INTERVAL milliseconds
    this.userId = this.$store.getters.userId;
    this.readNotifications();
    this.pollingNotifications = setInterval(() => {
      this.readNotifications();
    }, config.NOTIFICATION_REFRESH_INTERVAL);
  },
  beforeDestroy() {
    clearInterval(this.pollingNotifications);
  },
  computed: {
    ...mapGetters(["id", "roles"]),
  },
  filters: {
    formattoLocalDate: function (value) {
      if (value) {
        const format = "MM/DD/YYYY hh:mm:ss A";
        return moment.utc(value).local().format(format);
      }
    },
  },
  methods: {
    async readNotifications() {
      this.isShow = true;
      try {
        let result = await apiService.getNotifications(this.id);
        if (result.isSuccess && result.data.length > 0) {
          this.notificationsList = result.data;
          this.items = result.data.slice(0, 5);
          this.notificationsCount = result.data.filter(
            (item) => item.status == 1
          ).length;
          //Logic to show animation for bell icon
          // if (this.notificationsCount > 0) {
          //   this.isBellAnimation = true;
          //   setTimeout(() => {
          //     this.isBellAnimation = false;
          //   }, 10000);
          // }
        }
      } catch (err) {
        this.isShow = false;
        console.log("Unable to load the Notifications" + err);
      }
      // try {
      //   let result = await telematicsService.getNotifications(this.id);
      //   if (result) {
      //     console.log(result);
      //     // result.map(
      //     //   item => (item.name = item.details.charAt(0).toUpperCase())
      //     // );
      //     // this.notificationsList = result;
      //     // this.items = result.slice(0, 5);
      //     // this.notificationsCount = result.filter(
      //     //   item => item.isViewed == false
      //     // ).length;
      //     // if (this.notificationsCount > 0) {
      //     //   this.isBellAnimation = true;
      //     //   setTimeout(() => {
      //     //     this.isBellAnimation = false;
      //     //   }, 10000);
      //     // }
      //   }
      // } catch (err) {
      //   console.log("Unable to load the Notifications" + err);
      // }
    },
    // showAllNotifications() {
    //   this.isShow = false;
    //   this.items = this.notificationsList;
    // },
    // async handleClickItem(item) {
    //   if (!item.isViewed) {
    //     item.isViewed = true;
    //     try {
    //       let result = await telematicsService.updateNotification(item.id);
    //       if (result.isSuccess == true) {
    //         this.notificationsCount -= 1;
    //       }
    //     } catch (err) {
    //       console.log(err);
    //       //this.$toast.error("Unable to update the Notifications" + err);
    //     }
    //   }
    //   if (item.entity == "Ticket" && item.urlkey) {
    //     this.$router
    //       .push({
    //         name: "viewTicket",
    //         params: { id: item.urlkey }
    //       })
    //       .catch(() => {});
    //   } else if (item.entity == "Report" && item.urlkey) {
    //     this.$router
    //       .push({
    //         name: "ViewReportRequest",
    //         params: { id: item.urlkey }
    //       })
    //       .catch(() => {});
    //   }
    // },
    // async SaveMarkAsAllViewed() {
    //   this.items = this.notificationsList;
    //   for (let item of this.items) {
    //     if (!item.isViewed) {
    //       item.isViewed = true;
    //     }
    //   }
    //   try {
    //     let apiResult = await telematicsService.MarkAllAsViewed(this.userId);
    //     if (apiResult.isSuccess == true) {
    //       this.notificationsCount = 0;
    //       this.$toast.success(" All Notifications are marked as viewed");
    //     }
    //   } catch (err) {
    //     this.$toast.error("Unable to save Mark All As Viewed" + err);
    //   }
    //   // }
    // }
    showAllNotifications() {
      this.isShow = false;
      this.items = this.notificationsList;
    },
    async handleClickItem(item) {
      if (!item.isViewed) {
        item.isViewed = true;
        try {
          let result = await apiService.updateNotification(item.notificationId);

          if (result.isSuccess == true) {
            this.notificationsCount -= 1;
            if (item.entityType == "Service") {
              this.$router
                .push(`/services?id=${item.entityId}`)
                .catch(() => {});
            } else if (item.entityType == "FleetEvents") {
              if (this.roles == "Customer") {
                let mapQuery = { navigateFrom: "Map", assetId: item.entityId };
                this.viewfinalRouteQuery = {
                  ...mapQuery,
                };
                this.$router.push({
                  name: "View Customer Owned Equipment Details",
                  params: { assetId: item.entityId },
                  // params: { id: unitID, equipId: equipId },
                  query: this.viewfinalRouteQuery,
                });
              } else {
                let mapQuery = { navigateFrom: "Map", assetId: item.entityId };
                this.viewfinalRouteQuery = {
                  ...mapQuery,
                };
                this.$router.push({
                  name: "View Rental Equipment Details",
                  params: { assetId: item.entityId },
                  // params: { id: unitID, equipId: equipId },
                  query: this.viewfinalRouteQuery,
                });
              }
            } else {
              this.$router
                .push({
                  name: "editUser",
                  params: { id: item.entityId },
                  query: { filterVal: "", isFilter: false },
                })
                .catch(() => {});
            }
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    async SaveMarkAsAllViewed() {
      try {
        this.isMarkingAllRead = true;
        let apiResult = await apiService.markAllAsViewed(this.id);
        if (apiResult.isSuccess == true) {
          this.isMarkingAllRead = false;
          this.notificationsCount = 0;
          this.items = [];
        }
      } catch (err) {
        this.isMarkingAllRead = false;
        this.$toast.error("Unable to Mark All As Read " + err);
      }
    },
  },
};
</script>
